// Shared timestamp-resolution logic for the Templates views.
//
// The list API exposes `time_updated`, but creating a new (default) version
// bumps the PREVIOUS version's `time_updated` on the backend, making the two
// newest versions appear to share a date. Prefer an immutable creation
// timestamp when the API provides one; otherwise fall back to `time_updated`.
//
// Kept in a small standalone module (rather than exported from index.js) so the
// compare/timeline components can import it without a circular dependency.
export const CREATION_TIME_FIELDS = [
  "time_created",
  "created_at",
  "date_created",
  "creation_time",
  "created",
];

export const getTemplateDisplayTime = (template) => {
  if (!template) return undefined;
  for (const field of CREATION_TIME_FIELDS) {
    if (template[field] !== undefined && template[field] !== null) {
      return template[field];
    }
  }
  return template.time_updated;
};
